<template>
    <div>
        <spinner/>
        <v-login/>
        <v-suspended/>
        <q-layout :view="layout">

            <!-- Navbar -->
            <q-layout-header>
                <v-header @drawerToogle="right = !right"/>
            </q-layout-header>

            <!-- Left Side Panel -->
            <q-layout-drawer side="right" v-model="right" behavior="mobile">
                <v-menu/>
            </q-layout-drawer>

            <!-- Content -->
            <q-page-container style="padding-bottom: 100px;">
                <router-view/>
                <v-social/>
            </q-page-container>

            <!-- Navbar -->
            <q-layout-footer>
                <v-footer/>
            </q-layout-footer>

        </q-layout>
    </div>
</template>

<script>
import VHeader from "../components/Header";
import VMenu from "../components/Menu";
import VFooter from "../components/Footer";
import VLogin from "../pages/auth/login";
import VSuspended from "../pages/auth/suspended";
import VSocial from "../components/Social"

import {
  QLayout,
  QLayoutHeader,
  QLayoutDrawer,
  QLayoutFooter,
  QPageContainer
} from "quasar-framework";

export default {
  name: "MainLayout",

  components: {
    VHeader,
    VMenu,
    VFooter,
    VSocial,
    VLogin,
    QLayout,
    VSuspended,
    QLayoutHeader,
    QLayoutDrawer,
    QLayoutFooter,
    QPageContainer
  },

  data() {
    return {
      right: false
    };
  },

  mounted() {
      document.getElementById("loader").style.display = "none";
  },

  computed: {
    layout() {
      if (this.$breakpoints.isGreaterThan("sm")) return "lhr lpr lFr";
      return "lHr lpr lFr";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue